module.exports = __webpack_public_path__ + "static/media/mm.5ab1b712.svg";